import { createFileRoute } from "@tanstack/react-router";

import { AdminLayout } from "@/components/routes/AdminLayout";
import { requireAdmin } from "@/utils/routeGuards";

export const Route = createFileRoute("/app/admin")({
  beforeLoad: async ({ location }) => {
    await requireAdmin(location);
  },
  component: AdminLayout,
});
